var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 84,
    viewBox: "0 0 80 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_7190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 81.7006L24.359 27.0339H54.9359L76 81.7006H5.33334Z",
    fill: "url(#paint0_linear_15_7190)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M16.2921 19.0752C16.2172 8.6062 26.6667 0.074515 39.588 2.48122e-06C52.5094 -0.0745101 63.0712 8.34541 63.1086 18.7772L16.2921 19.0752Z",
    fill: "#EABBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0299 18.7772C25.9924 11.5868 32.5093 5.70028 40.6366 5.66302C48.7639 5.62576 55.3557 11.4005 55.3932 18.6282L26.0299 18.7772Z",
    fill: "#A5DEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.292 19.0751L3.67032 23.9185L75.543 23.5086L63.3707 18.7771L16.292 19.0751Z",
    fill: "#9201EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.991 23.4876L-0.0090332 23.9778L0.0108075 27.1818L80.0108 26.6916L79.991 23.4876Z",
    fill: "#551578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1948 33.5679C24.1948 33.5679 8.61432 30.2894 4.64429 27.1226L27.9402 26.9736L75.0937 26.6755C75.0937 26.6755 65.0188 33.4934 55.6181 33.3817C55.6181 33.3817 55.5057 36.5857 51.8353 36.5857C48.1649 36.623 28.2398 36.7347 28.2398 36.7347C28.2398 36.7347 23.708 35.9896 23.708 33.4562",
    fill: "#9201EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6104 5.62573C41.6104 5.62573 49.7752 10.6181 46.5917 18.6282L54.0449 18.5909C54.0449 18.5909 53.7078 7.86111 41.6104 5.62573Z",
    fill: "#DCF6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.764 15.7221C28.7266 15.5731 28.6891 15.424 28.6891 15.275C28.5393 12.5926 31.9475 8.34535 34.7191 8.12181C35.8052 8.0473 37.1161 9.05322 36.4794 10.2082C35.6554 11.7357 34.6067 13.1142 33.5206 14.4554C32.734 15.4613 31.7228 17.2123 30.1872 16.877C29.5131 16.7653 28.9887 16.3555 28.764 15.7221Z",
    fill: "#DCF6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6253 15.4242C39.6253 16.4674 38.8013 17.3243 37.7152 17.3243C36.6665 17.3243 35.8051 16.5047 35.8051 15.4242C35.8051 14.3811 36.6291 13.5242 37.7152 13.5242C38.7639 13.5614 39.6253 14.3811 39.6253 15.4242Z",
    fill: "#DCF6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92166 24.8237L1.19507 24.8772L1.20246 26.0694L9.92905 26.0159L9.92166 24.8237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1053 24.8238L14.3787 24.8772L14.386 26.0694L23.1126 26.016L23.1053 24.8238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3263 24.8238L27.5997 24.8772L27.6071 26.0694L36.3337 26.016L36.3263 24.8238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5102 24.8609L40.7836 24.9143L40.791 26.1065L49.5176 26.0531L49.5102 24.8609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7312 24.749L54.0046 24.8025L54.012 25.9947L62.7386 25.9412L62.7312 24.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9152 24.6374L67.1886 24.6909L67.196 25.8831L75.9225 25.8296L75.9152 24.6374Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_7190",
    x1: 40.6667,
    y1: 27.0339,
    x2: 40.6667,
    y2: 81.7006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C61CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_7190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 83.034,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfo);
export default __webpack_public_path__ + "static/media/ufo.0921062f821640dfd78f3d25fa5f22a4.svg";
export { ForwardRef as ReactComponent };